package ir.hosen.resume.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val NavTabItemStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 12.px)
            .background(Colors.Transparent)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }
    hover {
        Modifier
            .backgroundColor(rgba(255, 255, 255, 0.10f))
            .padding(leftRight = 20.px)
    }
}